<div class="app-titulo-pagina">
  <span>Nova Transferência entre Cartões</span>
</div>
<div class="container">
  <article *ngIf="!processando" class="col-xs-12 col-md-8 col-md-offset-2 app-msg-transf">
    <h4>
      Na transferência <strong>entre cartões</strong> você pode transferir seus pontos para qualquer chave
      PicPontos apenas com o número do cartão.
    </h4>
  </article>
  <form *ngIf="!processando" class="col-xs-12 col-md-8 col-md-offset-2" ngNativeValidate>
    <div class="panel panel-default">
      <div class="panel-title">
        Dados do Favorecido
      </div>
      <div class="panel-body">
        <div class="form-group">
          <div *ngIf="!cartaoLocalizado">
            <label>Número do Cartão Destino</label>
            <input name="cartaoDestino" [(ngModel)]="cartaoDestino" type="text" class="form-control input-sm"
              id="cartaoDestino" UiCartao uiEnter="validarCartao">
            <button type="button" (click)="localizaCartao()" class="btn btn-success-v2" id="validarCartao"
              style="margin-top:7px; margin-bottom: 7px;">
              Validar
            </button>
          </div>

          <div *ngIf="cartaoLocalizado != undefined">
            <br />
            <label>Número do Cartão</label>
            <input value="{{ cartaoLocalizado.numero }}" type="text" class="form-control input-sm" disabled
              id="NumCrtLocalizado">
            <label>Titular do Cartão</label>
            <input value="{{ cartaoLocalizado.nome }}" type="text" class="form-control input-sm" disabled
              id="titularCartao">
            <label>Documento</label>
            <input value="{{ cartaoLocalizado.documento }}" type="text" class="form-control input-sm" disabled
              id="titularDoc">

            <label>Valor em Pontos</label>
            <input name="valorPontos" [(ngModel)]="valorPontos" type="text" class="form-control input-sm"
              id="valorTransfCartao" UiPontos required>
            <label>Taxa de Transferência</label>
            <input value="{{ taxaTransferencia }}" type="text" class="form-control input-sm" disabled
              id="taxaTransfCartao">
            <label>Total em Pontos</label>
            <input value="{{ calcularTotal() }}" type="text" class="form-control input-sm" disabled id="vlrTransfTotal">
          </div>
        </div>
        <div class="col-xs-12 text-left">
          <div class="alert alert-warning" role="alert">
            <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Não serão realizadas transferências para
              cartões
              com cadastro de portador incompleto.</p>
            <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Será cobrada uma tarifa de
              {{taxaTransferencia}}
              pontos (por solicitação).</p>
            <p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> O limite máximo para transferência é de
              {{limiteTransferencia}}
              pontos (por solicitação).</p>

          </div>
        </div>
        <div *ngIf="valorPontos !=undefined">
          <label>Senha eletrônica</label>
          <input name="epwd" id="senha" [(ngModel)]="epwd" type="password" class="form-control input-sm" required>
        </div>

      </div>
      <div class="col-xs-12 text-center" style="margin-top: 2em;">
        <a id="btn-voltar" (click)="mainService.loginService.changeRoute('transferencias')" class="btn btn-danger-v2">
          Voltar
        </a>
        <button id="confirmar-transferencia" type="button" class="btn btn-success-v2"
          *ngIf="epwd != undefined && epwd.length >= 1" (click)="save()">
          Confirmar
        </button>
      </div>
    </div>
  </form>
  <div *ngIf="processando" class="text-center">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/transferencia/cartao/cartao.component.html